import { faTimes } from '@fortawesome/pro-light-svg-icons'
import TwinIcon from '../../baseComponents/TwinIcon'
import { TwinDictionary } from '../../utils/globals/dictionary'
import { useCallback } from 'react'
import { twinFetchPostJSON } from '../../utils/globals/data'

export interface TitleAndDeleteOrderHeaderOptionProps extends TitleAndDeleteOrderHeaderOptionLogicProps {
    fieldName?: string
}

const TitleAndDeleteOrderHeaderOption: React.FC<TitleAndDeleteOrderHeaderOptionProps> = ({ option, getCompleteData, url, fieldValue, fieldName = 'name' }) => {
    const { deleteOrderOption } = useTitleAndDeleteOrderHeaderOptionLogic({ option, getCompleteData, url, fieldValue })
    return (
        <div className='flex justify-between items-center mb-17'>
            <span className='regular18'>
                {option?.[fieldName]}
            </span>
            <TwinIcon className='cursor-pointer' icon={faTimes} onClick={deleteOrderOption} />
        </div>
    )
}
interface TitleAndDeleteOrderHeaderOptionLogicProps {
    fieldValue: string
    option: TwinDictionary
    url: string
    getCompleteData: () => void
}

const useTitleAndDeleteOrderHeaderOptionLogic = ({ option, getCompleteData, url, fieldValue = 'id' }: TitleAndDeleteOrderHeaderOptionLogicProps) => {
    const deleteOrderOption = useCallback(async () => {
        const result = await twinFetchPostJSON(url, { OrderId: option?.OrderId, [fieldValue]: option?.[fieldValue] })
        if (result) {
            getCompleteData()
        }
    }, [option, fieldValue, getCompleteData, url])

    return { deleteOrderOption }
}

export default TitleAndDeleteOrderHeaderOption